import React, { Component } from 'react'
import PropTypes from "prop-types";
import {Icon} from 'semantic-ui-react'

class OrderByHeader extends Component {
    //access router
    //this.props.history.push('/dashboard')
    _onSortClicked = () => {
        const {field, currentValue, onSortListChange} = this.props;
        let nextValue = "asc";
        if (currentValue === 'asc') {
            nextValue = "desc"
        } 
        if (currentValue === 'desc') {
            nextValue = ""
        }
        if (currentValue === "") {
            nextValue = "asc"
        }

        onSortListChange(field, nextValue);
    }

    render() {
        return (
            <a onClick={this._onSortClicked} href='javascript:;'>
                {this.props.headerName} 
                {this.props.currentValue === 'asc' ? <Icon name='sort alphabet down' /> : null}
                {this.props.currentValue === 'desc' ? <Icon name='sort alphabet up' /> : null}
                {this.props.currentValue === '' ? <Icon name='sort' /> : null}
            </a>
        )
    }
}

OrderByHeader.propTypes = {
    headerName: PropTypes.string.isRequired,
    currentValue: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
    onSortListChange: PropTypes.func.isRequired
};

export default OrderByHeader


// WEBPACK FOOTER //
// ./src/components/utils/tables/OrderByHeader.js